<div class="customize-fields-switch-form__container">
  @if(concept?.allowPublicShare){
    @if (typeView !== 'channelView'){
      <field-type-switch
        [field]="{label: 'customize.private'| afTranslate}"
        [small]="small"
        [preSelectItem]="isPrivate?isPrivate:field.private"
        [disabled]="customizeFieldsSwitchForm.disabledFormConfiguration || isPrivate || (this.concept.allowPublicShare && (this.field.fieldTypeId === 'task' || this.field.fieldTypeId === 'alert'))"
        (itemSelected)="changeOptionOn($event, 'private')">
      </field-type-switch>
    }
  }@else{
    <field-type-switch
      [field]="{label: 'customize.hidden-landing-variant'| afTranslate}"
      [small]="small"
      [preSelectItem]="hiddenInLandings?hiddenInLandings:field.hiddenInLandings"
      [disabled]="customizeFieldsSwitchForm.disabledFormConfiguration || hiddenInLandings"
      (itemSelected)="changeOptionOn($event, 'hiddenInLandings')">
    </field-type-switch>
  }
  @if(field.fieldTypeId === 'rich' || field.fieldTypeId === 'bool' || field.fieldTypeId === 'boolp'){
    <field-type-switch
      [field]="{label: 'customize.highlight'| afTranslate}"
      [small]="small"
      [preSelectItem]="field.isHighlight"
      [disabled]="customizeFieldsSwitchForm.disabledFormConfiguration || field.isEditable"
      (itemSelected)="changeOptionOn($event, 'isHighlight')">
    </field-type-switch>
  }
  @if(field.fieldTypeId !== 'formu' && field.fieldTypeId !== 'formp' && field.fieldTypeId !== 'templ' && field.fieldTypeId !== 'task' && field.fieldTypeId !== 'alert'){
    <field-type-switch
      [field]="{label: 'customize.required'| afTranslate}"
      [small]="small"
      [preSelectItem]="field.required"
      [disabled]="field.noEditable || (field.fieldTypeId === 'rich' && !field.isEditable) || customizeFieldsSwitchForm.disabledFormConfiguration || field.isDisaggregated || field.isManagerClassificator"
      (itemSelected)="changeOptionOn($event, 'required')">
    </field-type-switch>
  }
  @if(concept?.poll && (field.fieldTypeId === 'bool' || field.fieldTypeId === 'boolp' || field.fieldTypeId === 'list' || field.fieldTypeId === 'listp')){
    <field-type-switch
      [field]="{label: 'customize-field-list.dissgregated-data'| afTranslate}"
      [small]="small"
      [preSelectItem]="field.isDisaggregated"
      [disabled]="field.noEditable || concept.disabled || previewMode"
      (itemSelected)="changeOptionOn($event, 'isDisaggregated')">
    </field-type-switch>
  }
</div>
